export default __webpack_public_path__ + "static/face-pro-69393a143b90423da6782f6b1410f382.png";